export type Environments =
  | "production"
  | "tour"
  | "development"
  | "staging"
  | "test";

const shouldUseEnvFileValues = (): boolean => {
  return process.env.REACT_APP_INFER_ENV_FROM_DOMAIN !== "true";
};
// for errors we want in rollbar and the console, but do not want to interrupt the flow of the application
const asyncThrow = function (message: string) {
  setTimeout(() => {
    throw new Error(message);
  }, 0);
};

const inferEnvFromDomain = function (): Environments | undefined {
  const environmentMap: Partial<Record<Environments, RegExp[]>> = {
    production: [/id\.justworks\.com/],
    tour: [
      /id-tour\.justworks\.com/,
      /pim-tour\.nonprod\.vibe\.justworks\.com/,
    ],
    staging: [/pim\.nonprod\.vibe\.justworks\.com/],
    development: [/localhost/],
  };

  const match = Object.entries(environmentMap).find(([_, regexes]) => {
    return regexes.some((regex) => regex.test(window.location.hostname));
  }) as [Environments, RegExp[]];

  return match?.[0];
};

export function getEnvironmentName(): Environments {
  const production: Environments = "production";
  let environmentName: Environments = process.env.NODE_ENV;

  if (!shouldUseEnvFileValues()) {
    const domainEnv = inferEnvFromDomain();
    if (domainEnv === undefined) {
      asyncThrow(
        "Cannot resolve environment. Could not infer from page domain. Defaulting to 'production'",
      );
    }
    environmentName = domainEnv || production;
  }

  return environmentName;
}
